import clsx from "clsx";

export function TypographyP(props: { className?: string; children: any }) {
  return (
    <p
      className={clsx("leading-7 [&:not(:first-child)]:mt-4", props.className)}
    >
      {props.children}
    </p>
  );
}
